import React, { useContext, useEffect } from 'react';
import makeBlockie from 'ethereum-blockies-base64';
import { IProfile, useProfile } from '../../hooks';

import './ProfileTemplate.scss';

export interface IOwnProps {
  children: React.ReactNode;
  className: string;
}

const profileContext = React.createContext<IProfile | undefined | null>(null);

export const useParentProfile = () => {
  return useContext(profileContext);
};

export default function ProfileTemplate({ children, className }: IOwnProps) {
  const { profile, getProfile } = useProfile();
  const data = profile ? makeBlockie(profile?.ethereumAddress) : undefined;

  useEffect(() => {
    getProfile();
  }, [getProfile])

  return <div className={`${className} profile`}>
    <section className="top-section bg-profile d-table w-100 bg-primary">
      <div className="container">
        <div className="card public-profile border-0 rounded shadow">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-lg-2 col-md-3 text-md-left text-center">
                <img src={data} className="avatar avatar-large rounded-circle shadow d-block mx-auto" alt="" />
              </div>
              <div className="col-lg-10 col-md-9">
                <div className="row align-items-end">
                  <div className="col-md-7 text-md-left text-center mt-4 mt-sm-0">
                    <h3 className="title mb-0">{profile?.name}</h3>
                    <small className="text-muted h6 mr-2">{profile?.email}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section">
      <div className="container mt-lg-3">
        <profileContext.Provider value={profile}>
          {
            children
          }
        </profileContext.Provider>
      </div>
    </section>;
  </div>
}